import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { QueryState } from "@/shared/ui/QueryState";
import { Button } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useClassSessionQuery, useUpdateClassSession } from "../api/queries";
import { ClassSessionForm } from "../ui/ClassSessionForm";

export function ClassSessionEditPage() {
  const nav = useNavigate({
    from: "/app/classes/sessions/$id/edit",
  });
  const { id } = useParams({ from: "/app/classes/sessions/$id/edit" });
  const { data, ...result } = useClassSessionQuery(id);
  const updateSession = useUpdateClassSession(id);

  const session = data;

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຈັດຕາຕະລາງຄລາດສ໌", to: "/app/classes/sessions" },
            { label: "ແກ້ໄຂ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ແກ້ໄຂ ຊົ່ວໂມງຮຽນ ຄລາດສ໌
            </h2>
            <p className="text-muted-foreground">ແກ້ໄຂ ຊົ່ວໂມງຮຽນ ຄລາດສ໌ໃນລະບົບ.</p>
          </div>

          <Button
            variant="outline"
            onClick={() =>
              nav({
                to: "/app/classes/sessions/$id",
                params: { id },
              })
            }
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <QueryState
          result={result}
          title="ກຳລັງໂຫຼດຊົ່ວໂມງຮຽນ"
          description="ກຳລັງດຶງລາຍລະອຽດ"
          variant="fullscreen"
        >
          {!session ? null : (
            <div className="mt-6">
              <ClassSessionForm
                initialValues={{
                  templateId: session.templateId,
                  date: session.date,
                  status: session.status,
                  startTime: session.startTime,
                  endTime: session.endTime,
                  locationKind: session.locationKind,
                  offSiteLabel: session.offSiteLabel ?? "",
                  engagementKind: session.engagementKind,
                  roomId: session.roomId ?? "",
                  instructors: session.instructors,
                  capacity: session.capacity,
                  notes: session.notes || "",
                }}
                sessionId={id}
                onSubmit={async (vals) => {
                  try {
                    const result = await updateSession.mutateAsync({
                      templateId: vals.templateId,
                      date: vals.date,
                      status: vals.status,
                      startTime: vals.startTime,
                      endTime: vals.endTime,
                      locationKind: vals.locationKind,
                      offSiteLabel:
                        vals.locationKind === "off_site"
                          ? (vals.offSiteLabel?.trim() || null)
                          : null,
                      engagementKind: vals.engagementKind,
                      roomId:
                        vals.locationKind === "off_site"
                          ? null
                          : vals.roomId,
                      instructors: vals.instructors,
                      capacity: vals.capacity,
                      notes: vals.notes,
                      changeReason: vals.changeReason,
                    });
                    nav({
                      to: "/app/classes/sessions/$id",
                      params: { id: result.id },
                    });
                  } catch {
                    // Error handling is done by the mutation
                  }
                }}
                onSubmitAndStay={async (vals) => {
                  try {
                    await updateSession.mutateAsync({
                      templateId: vals.templateId,
                      date: vals.date,
                      status: vals.status,
                      startTime: vals.startTime,
                      endTime: vals.endTime,
                      locationKind: vals.locationKind,
                      offSiteLabel:
                        vals.locationKind === "off_site"
                          ? (vals.offSiteLabel?.trim() || null)
                          : null,
                      engagementKind: vals.engagementKind,
                      roomId:
                        vals.locationKind === "off_site"
                          ? null
                          : vals.roomId,
                      instructors: vals.instructors,
                      capacity: vals.capacity,
                      notes: vals.notes,
                      changeReason: vals.changeReason,
                    });
                  } catch {
                    // Error handling is done by the mutation
                  }
                }}
                submitting={updateSession.isPending}
                isEdit={true}
              />
            </div>
          )}
        </QueryState>
      </Main>
    </>
  );
}
